import * as PIXI from 'pixi.js';

export class TrackMatteFilter extends PIXI.MaskFilter {
    #matted: PIXI.Container;

    constructor(sprite: PIXI.Sprite, matted: PIXI.Container) {
        super({ sprite, channel: 'alpha', resolution: 'inherit' });
        this.#matted = matted;
    }

    #rootWorldTransform(): PIXI.Matrix {
        let root: PIXI.Container = this.#matted;
        while (root.parent) {
            root = root.parent;
        }
        return root.worldTransform;
    }

    override apply(
        filterManager: PIXI.FilterSystem,
        input: PIXI.Texture,
        output: PIXI.Texture,
        clearMode: boolean,
    ) {
        this.sprite.worldTransform.copyFrom(this.#rootWorldTransform());
        super.apply(filterManager, input, output, clearMode);
    }
}
